import { useState } from "react";
import { TextField, Button, Card, CardContent, Typography, Stack } from "@mui/material";
import { SUCCESS_TOAST, ERROR_TOAST, INFO_TOAST } from "../../../helpers/toasters";
import { Link } from "react-router-dom";
import { forgotPassword } from "../../../API/adminDetails";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await forgotPassword(email);
            

            if (res.role === "coach") {
                INFO_TOAST("Please contact admin@suprkid.in to reset your password.");
            } else if (res.role === "admin" || res.role === "super_admin") {
                SUCCESS_TOAST("Password reset link has been sent to your email.");
                setEmail("");
            } else if (res.role === "none") {
                INFO_TOAST("No user found with this email.");
            } else {
                ERROR_TOAST("Unexpected response. Please try again.");
            }

        } catch (error: any) {
            ERROR_TOAST(
                error?.response?.data?.message ||
                "Failed to process request. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f3f4f6",
                padding: "16px",
            }}
        >
            <Card sx={{ width: "100%", maxWidth: 400, padding: 3 }}>
                <CardContent>
                    <Typography variant="h5" component="h2" align="center" gutterBottom>
                        Forgot Password
                    </Typography>

                    <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                        <TextField
                            type="email"
                            label="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            fullWidth
                        />
                        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
                            {loading ? "Processing..." : "Send Reset Link"}
                        </Button>
                    </form>

                    <Stack direction="row" justifyContent="center" mt={2}>
                        <Typography variant="body2">
                            Remembered your password?{" "}
                            <Link to="/login" style={{ textDecoration: "none", color: "#1976d2", fontWeight: "bold" }}>
                                Back to Login
                            </Link>
                        </Typography>
                    </Stack>
                </CardContent>
            </Card>
        </div>
    );
};

export default ForgotPassword;
